interface Props {
    input: {
        value: any;
    };
}

const RenderValue = ({ input: { value } }: Props): any => value;

export default RenderValue;
